import React, { useState } from 'react'
import Select from 'react-select'
import { Link, Route, Switch } from 'react-router-dom'
import { DatePicker, Menu, Dropdown } from 'antd'

import { FaHandHolding } from 'react-icons/fa'
import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { stringifyDate, useListData, useSocketEvents, useToggle, usePet } from '../../modules'

import Receive from '../../components/reusable/receive'
import Patient from '../../components/reusable/patient'
import Confirm from '../../components/reusable/confirm'

import PatientDetails from '../../components/drawers/patient'
import TheatreRecord from '../../components/drawers/theatre'
import RecordTheatre from '../../components/drawers/recordTheatre'

import Forward from '../../components/modals/forward'

const { RangePicker } = DatePicker

const OpNotes = () => {
    const [ranges, setRanges] = useState()
    const [chosen, setChosen] = useState([])
    const [type, setType] = useState({ label: 'All', value: 'All' })
    const [string, setString] = useState('')
    const [selected, setSelected] = useState('')
    const [sIString, setSIString] = useState('')
    const [pendingForwards, setFCount] = useState(0)
    const [cId, setCId] = useState()
    
    const [select, toggleSelect] = useToggle()
    const [forward, toggleForward] = useToggle()
    const [notSeen, toggleNSeen] = useToggle(true)

    // usePet('pendingAppointments', null, { notify: false, callback: ({ data }) => setPCount(data) })

    // usePet('pendingForwards', null, { notify: false, callback: ({ data }) => setFCount(data) })

    const [
        { loading: qLoading, error: qError, fetch: fetchBillItems },
        { list: queue },
        { page = 1, limit = 10, navigate, Paginate }
    ] = useListData('billedItemsByCategory', ranges ? { 
        category: 'Theatre Operations',
        string, 
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null,
        order: -1,
    } : { string, category: 'Theatre Operations', order: -1 }, { notify: true }, 'items')

    const [
        { loading: sILoading, error: sIError, fetch: fetchSaleItems },
        { list: saleItems = [] }
    ] = useListData('pointOfSaleItems', { category: 'Theatre Operations', string: sIString }, { notify: true }, 'items')

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const refresh = () => {
        navigate(1)
        fetchBillItems()
        fetchSaleItems()
    }

    useSocketEvents({
        'new-patient': {
            condition: data => data.destination === 'Theatre',
            notif: {
                message: 'New Patient',
                type: 'info'
            },
            callback: refresh
        }
    })

    const filterByType = typ => {
        setType(typ)
        refresh()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const forwardPatient = item => {
        setSelected(item._id)
        toggleForward()
    }

    const onSComplete = (_, notif, ops) => {
        refresh()
        notif('Changes have been saved', ops('success'))
    }

    const [{ loading: sLoading }, toggleSeen] = usePet('toggleSeenStatus', { 
        id: cId
    }, { notify: true, callback: onSComplete, manual: true })

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Modals */}
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Patient Name, OP/IP No." />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <RangePicker onChange={selectRange} />
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={() => null}>Patient Visits</Menu.Item>
                            </Menu>
                        }>
                        <button className="btn hisani-btn-green-light ml-2 text-white">
                            <span className="hidden xs:block mr-2">Reports</span>
                            <AiOutlineDown />
                        </button>
                    </Dropdown>
                </div>
            </div>
            <Forward
                source="Theatre"
                item={ selected }
                toggle={ toggleForward }
                visible={ forward }
                destination="Doctor" />
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800 mb-1">Operation Notes</h2>
                    <span className="flex items-center justify-between">
                        <Receive
                            loading={sILoading}
                            error={sIError}>
                            <Select
                                value={type}
                                onChange={filterByType}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ [{ label: 'All', value: 'All' }, ...saleItems.map(item => ({ label: item.name, value: item._id }))] }
                                placeholder="Filter By Type" />
                        </Receive>
                        <button onClick={refresh} className="btn ml-2 py-2.5 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                        <Link className="ml-2" to={ `/app/theatre/operation-notes/requests` }>
                            <button className="btn hisani-btn-green-light text-white flex items-center justify-between">
                                <FaHandHolding />
                                <span className="xs:block ml-2">Requests</span>
                            </button>
                        </Link>
                        <Link to="/app/theatre/operation-notes/new">
                            <button className="btn ml-2 py-2.1 hisani-btn-green-light text-white">New Entry</button>
                        </Link>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={qLoading}
                        error={qError}>
                        {
                            queue?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Procedure</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Date / Time</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                queue.map((item, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                {
                                                                    select ?
                                                                        <input
                                                                            onChange={() => choose(item._id)}
                                                                            checked={chosen.includes(item._id)}
                                                                            type="checkbox"
                                                                            className="form-checkbox cursor-pointer h-5 w-5" />
                                                                        :
                                                                        `${((page - 1) * limit) + (key + 1)}.`
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Patient patient={ item?.patient } />
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ item.ref?.name ?? item.name }{ item.quantity > 1 && ` (x ${item.quantity})` }</div>
                                                            <div className="flex space-x-2 pl-1 items-center">
                                                                <div className={ `w-2 h-2 rounded-full bg-${ item.seen? 'green' : 'yellow'}-500 shadow` }></div>
                                                                <p className={ `text-${ item.seen? 'green' : 'yellow'}-500 text-xs italic mb-0` }>{ item.seen? 'Filled' : 'Pending' }</p>
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{stringifyDate(item.date)}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Link to={ `/app/theatre/operation-notes/${item._id}` }><Menu.Item>{ item.filled ? 'Review' : 'View' } Record</Menu.Item></Link>
                                                                        <Link to={ `/app/theatre/operation-notes/patients/${ item?.patient?._id }` }><Menu.Item>Patient Details</Menu.Item></Link>
                                                                        <Menu.Item onClick={ () => forwardPatient(item) }>Forward Patient</Menu.Item>
                                                                        {
                                                                            !item.filled &&
                                                                            <Menu.Item onClick={ () => null }>{ item.discarded ? 'Restore' : 'Discard' }</Menu.Item>
                                                                        }
                                                                        {
                                                                            (item?.seen || item?.served) &&
                                                                            <Menu.Item onClick={ () => {
                                                                                setCId(item?._id)
                                                                                Confirm({
                                                                                    title: 'Mark Item as Unseen?',
                                                                                    message: 'This will revert the selected item back to the pending queue',
                                                                                    okText: 'Mark as Unseen',
                                                                                    onOk: toggleSeen
                                                                                })
                                                                            } }>Mark as Unseen</Menu.Item>
                                                                        }
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">No patients { string.trim().length > 2 ? `matching "${string}"` : "" } were found</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
            <Switch>
                <Route exact path="/app/theatre/operation-notes/new">
                    <RecordTheatre onCreate={ refresh } />
                </Route>
                <Route path="/app/theatre/operation-notes/patients/:id">
                    <PatientDetails reload={ refresh } source="/app/theatre/operation-notes" />
                </Route>
                <Route path="/app/theatre/operation-notes/:id">
                    <TheatreRecord title="Operation Notes" onClose={ refresh } />
                </Route>
            </Switch>
        </div>       
    )
}

export default OpNotes